<template>
    <div class="app-topnav">
        <common-icon
            name="menu"
            size="gigantic"
            class="app-topnav__menu-icon"
            @click="emitEvent({ name: 'toggle-sidenav' })"
        ></common-icon>
        <div class="app-topnav__quick-actions">
            <app-make-referral-menu v-if="showReferralMenu"></app-make-referral-menu>
            <app-track-referrals-menu v-if="!$auth.isUserAdministrator()"></app-track-referrals-menu>
        </div>

        <div
            v-if="!$auth.isUserAdministrator() && !$auth.isUserPracticeOther() && !$auth.isUserTemporaryPhysician()"
            class="app-topnav__unread-messages"
        >
            <unread-referral-messages></unread-referral-messages>
        </div>

        <div v-if="!$auth.isUserPracticeOther()" class="app-topnav__calendar">
            <b>{{ today.format('DD') }}</b>
            <span>{{ today.format('MMM') }}</span>
        </div>

        <div class="app-topnav__user-menu">
            <app-user-menu
                :isOnlyLogoutAvailable="$auth.isUserPracticeOther() || $auth.isUserPracticeDemo()"
                @emitEvent="emitEvent($event)"
            ></app-user-menu>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import AppUserMenu from 'components/layouts/app-layout/AppUserMenu'
    import AppMakeReferralMenu from 'components/layouts/app-layout/AppMakeReferralMenu'
    import AppTrackReferralsMenu from 'components/layouts/app-layout/AppTrackReferralsMenu'
    import UnreadReferralMessages from 'components/page-elements/referrals/messages/UnreadReferralMessages'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],

        components: {
            AppUserMenu,
            AppMakeReferralMenu,
            AppTrackReferralsMenu,
            UnreadReferralMessages,
        },

        computed: {
            showReferralMenu() {
                return (
                    this.$auth.isActiveMemberPhysician() ||
                    this.$auth.isPracticeAncillary() ||
                    this.$auth.isUserPracticeOther() ||
                    this.$auth.isUserPracticeDemo()
                )
            },
            today() {
                return dayjs()
            },
        },
    }
</script>
